import { useQuery } from 'react-query';
import useBrowserAuthMe from '../useBrowserAuthMe';
import { fetchMyConversations } from './api';
import { exponentialBackoffDelayMs } from '../../utils/api/apiHelper';
/**
 * Period for when to update the conversation list
 * */
var CHAT_REFRESH_RATE_MS = 60000;
var UNREAD_MESSAGES_REFRESH_RATE_MS = 180000;
var hasValidMessage = function (conversation) {
    var latestMessage = conversation.latestMessage;
    return !!latestMessage;
};
var isValidConversation = function (conversation) {
    if (!hasValidMessage(conversation)) {
        console.warn("Discovered an invalid conversation " + conversation.slug + ", because it doesn't have any messages");
        return false;
    }
    return true;
};
/**
 * Retrieves the latest conversations in a fixed interval.
 * It also ensures that only valid conversations are presented to the user,
 * so the user does not get confused by these.
 *
 * Invalid conversations might be those with no classifieds or no messages.
 * */
var useLatestConversationList = function (hasHigherRefreshRate) {
    if (hasHigherRefreshRate === void 0) { hasHigherRefreshRate = false; }
    var _a = useBrowserAuthMe(), isUserLoading = _a.isLoading, user = _a.user;
    var refreshRate = hasHigherRefreshRate ? UNREAD_MESSAGES_REFRESH_RATE_MS : CHAT_REFRESH_RATE_MS;
    var _b = useQuery(['conversations'], function () { return fetchMyConversations(); }, {
        enabled: !!user,
        // Set to static 10 now, but it should typically disable on non-recoverable errors.
        // HTTP 5xx and HTTP 4xx errors may still be recoverable
        retry: 1,
        retryDelay: exponentialBackoffDelayMs,
        staleTime: 1800000,
        refetchInterval: refreshRate,
        // If we experience very high load on our server can this be deactivated,
        // and instead only re-fetch when the user has the window in focus.
        refetchIntervalInBackground: true,
        onError: function (err) {
            console.error('Failed to fetch latest conversations for user', err);
        },
    }), _c = _b.data, conversations = _c === void 0 ? [] : _c, isConversationsLoading = _b.isLoading, error = _b.error, refetch = _b.refetch;
    return {
        isLoading: isUserLoading || isConversationsLoading,
        forceReFetch: refetch,
        error: error !== null && error !== void 0 ? error : undefined,
        conversations: conversations.filter(isValidConversation),
    };
};
export default useLatestConversationList;
